import Vue from 'vue'
import Vuex from 'vuex'

import auth from './store-auth'
import report from './store-report'
import statement from './store-statement'

Vue.use(Vuex)

export default function (/* { ssrContext } */) {
  const Store = new Vuex.Store({
    modules: {
      auth,
      report,
      statement
    },

    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: process.env.DEV
  })

  return Store
}
